import GpTabs from "./components/GpTabs";
export { default as GpTab } from "./components/GpTab";
export { default as GpTabContent } from "./components/GpTabContent";
export { default as GpTabsContent } from "./components/GpTabsContent";
export { default as GpTabsNav } from "./components/GpTabsNav";
export { default as GpTabHeader } from "./components/GpTabHeader";

export default GpTabs;
